import {NgxDaterangepickerMd} from 'ngx-daterangepicker-material';
import {ApplicationConfig, importProvidersFrom} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {provideAnimations} from '@angular/platform-browser/animations';
import {Angulartics2Module} from 'angulartics2';
import {SweetAlert2Module} from '@sweetalert2/ngx-sweetalert2';
import {FullCalendarModule} from '@fullcalendar/angular';
import {CoreModule} from '~local/app/core/core.module';
import {provideRouter} from '@angular/router';
import {MatMomentDateModule} from '@angular/material-moment-adapter';
import {routes} from '~local/app/app-routes';

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(routes),
        provideAnimations(),
        importProvidersFrom([
            NgxDaterangepickerMd.forRoot(),
            TranslateModule.forRoot(),
            MatMomentDateModule,
            CoreModule,
            FullCalendarModule,
            SweetAlert2Module.forRoot(),
            Angulartics2Module.forRoot(),
        ]),

    ]
};
